module.exports = "/images/vendor/desiigner-svg/svg/ui/aereo-spinner.svg?ed3198a6f3a9fefba8327086062dab3d";